import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@material-ui/core';
import { Button, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const Addons = ({ addons }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Grid spacing={2}>
      {addons.length === 0 ? (
        <Button disabled={true}>
          {t('ecommerceBags.fields.bag.addons.empty')}
        </Button>
      ) : (
        <Button
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          {isOpen ? t('$*common.hide') : t('$*common.show')}{' '}
          {t('$*orderFormTabs.addons').toLowerCase()} (
          {addons
            .map(el => el.addon.quantity)
            .reduce((curr, prev) => prev + curr, 0)}
          )
        </Button>
      )}
      <Collapse in={isOpen} unmountOnExit={true}>
        <List disablePadding={true}>
          {addons.map(el => (
            <ListItem key={el['@id']}>
              <ListItemIcon>{el.addon.quantity} X</ListItemIcon>
              <ListItemText primary={el.addon.addon.name} />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Grid>
  );
};

export default Addons;
